/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-22 09:48:21
 * @LastEditTime: 2022-03-22 09:50:26
 * @LastEditors: Yandong Hu
 * @Description:
 */
export const DEFAULT_EXPORT_NAME = "无标题";
